<ng-container>
  <button type="submit" [disabled]="!isValid()">
    @if (formData.iconName) {
      <span class="material-symbols-rounded">
      {{ formData.iconName }}
    </span>
    }
    {{ formData.isTranslated ? (formData.label | translate) : formData.label }}
  </button>
</ng-container>
